import React from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import NotificationModal from "../../components/modals/Notification.Modal";
import {
getNotification,
updateNotificationSettings,
} from "./../../apis/tutors";
import { SettingHeader } from "./../TutorSetting/SpecificSettingComp";
import { InfoModal } from "./../../components/modals/InfoModal";

class TutorSettingNotification extends React.PureComponent {
	constructor() {
		super();
		this.state = {
		messagesText: false,
		messagesEmail: false,
		marketingEmails: false,
		updatesAndPromoText: false,
		updatesAndPromoEmail: false,
		jobOpportunitiesText: false,
		jobOpportunitiesEmail: false,
		notificationModalOpen: false,
		lessonAndFeedbackReminderText: false,
		lessonAndFeedbackReminderEmail: false,
		newRequestAndUpcomingLessonText: false,
		newRequestAndUpcomingLessonEmail: false,
		};
	}

	handleSwitchChange = (e) => {

		if(e.target.name === "marketingEmails") {

		const { marketingEmails } = this.state;

		if( marketingEmails ) {

			this.setState({ marketingEmails: false });

		}
		else this.setState({ marketingEmails: false, notificationModalOpen: true });

		}
		else this.setState({ [e.target.name]: e.target.checked });

	}

	unsubcribe = () => {

		this.setState({ marketingEmails: true, notificationModalOpen: false });

	};

	onClose = () => {

		this.setState({ doctoralCertificateOpenModal: false, notificationOpenModal: false });

	};

	onClose1 = () => {

		this.setState({ notificationModalOpen: false });

	};

	componentDidMount = () => {
		getNotification()
		.then((res) => {
			this.setState({
			newRequestAndUpcomingLessonText: res?.data?.newRequestAndUpcomingLessonText,
			newRequestAndUpcomingLessonEmail: res?.data?.newRequestAndUpcomingLessonEmail,
			messagesText: res?.data?.messagesText,
			messagesEmail: res?.data?.messagesEmail,
			lessonAndFeedbackReminderText: res?.data?.lessonAndFeedbackReminderText,
			lessonAndFeedbackReminderEmail: res?.data?.lessonAndFeedbackReminderEmail,
			jobOpportunitiesText: res?.data?.jobOpportunitiesText,
			jobOpportunitiesEmail: res?.data?.jobOpportunitiesEmail,
			updatesAndPromoText: res?.data?.updatesAndPromoText,
			updatesAndPromoEmail: res?.data?.updatesAndPromoEmail,
			marketingEmails: res?.data?.marketingEmails,
			});
			this.props.onclose();
		})
		.catch((err) => console.log(err));
	};

	UpdateNotification = () => {
		this.setState({
		loader: true,
		});
		const {
		newRequestAndUpcomingLessonText,
		newRequestAndUpcomingLessonEmail,
		messagesText,
		messagesEmail,
		lessonAndFeedbackReminderText,
		lessonAndFeedbackReminderEmail,
		jobOpportunitiesText,
		jobOpportunitiesEmail,
		updatesAndPromoText,
		updatesAndPromoEmail,
		marketingEmails,
		} = this.state;
		let updateSettingParam = {
		updateSetting: {
			newRequestAndUpcomingLessonText,
			newRequestAndUpcomingLessonEmail,
			messagesText,
			messagesEmail,
			lessonAndFeedbackReminderText,
			lessonAndFeedbackReminderEmail,
			jobOpportunitiesText,
			jobOpportunitiesEmail,
			updatesAndPromoText,
			updatesAndPromoEmail,
			marketingEmails,
		},
		};
		updateNotificationSettings(updateSettingParam)
		.then((res) => {
			this.setState({
			loader: false,
			});
			InfoModal("Updates", "Successfully Update");

		})
		.catch((err) => console.log(err));
	};

	render() {

		const { 
		loader,
		messagesText,
		messagesEmail,
		marketingEmails,
		updatesAndPromoText,
		updatesAndPromoEmail,
		jobOpportunitiesText,
		jobOpportunitiesEmail,
		notificationModalOpen,
		lessonAndFeedbackReminderText,
		lessonAndFeedbackReminderEmail,
		newRequestAndUpcomingLessonText,
		newRequestAndUpcomingLessonEmail,
		} = this.state;

		return (
		<div className="container tutor-setting-notification-modal">
			<Row className="flex-center-center">
			<Col lg={8} md={8} sm={12} xs={12} className="notification-div">
				<SettingHeader
				settingName={"Notiﬁcations"}
				headerTitle={"Notifications"}
				headerDesciption={"Set notiﬁcation for jobs and updates"}
				goToAccount={()=>this.props.history.push("/tutor-setting")}
				/>

				<h4 className="heading">New requests and upcoming lessons</h4>
				<div className="Switch">
				<p className="label">Text messages</p>
				<label className="switch">
					<input
					type="checkbox"
					onClick={this.handleSwitchChange}
					name="newRequestAndUpcomingLessonText"
					defaultChecked={newRequestAndUpcomingLessonText}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<div className="Switch">
				<p className="label">Email</p>
				<label className="switch">
					<input
					type="checkbox"
					onClick={this.handleSwitchChange}
					name="newRequestAndUpcomingLessonEmail"
					defaultChecked={newRequestAndUpcomingLessonEmail}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<hr className="hr"/>

				<h4 className="heading">Messages</h4>
				<div className="Switch">
				<p className="label">Text messages</p>
				<label className="switch">
					<input
					type="checkbox"
					name="messagesText"
					defaultChecked={messagesText}
					onClick={this.handleSwitchChange}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<div className="Switch">
				<p className="label">Email</p>
				<label className="switch">
					<input
					type="checkbox"
					name="messagesEmail"
					defaultChecked={messagesEmail}
					onClick={this.handleSwitchChange}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<hr className="hr"/>

				<h4 className="heading">Lesson and feedback reminders</h4>
				<div className="Switch">
				<p className="label">Text messages</p>
				<label className="switch">
					<input
					type="checkbox"
					onClick={this.handleSwitchChange}
					name="lessonAndFeedbackReminderText"
					defaultChecked={lessonAndFeedbackReminderText}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<div className="Switch">
				<p className="label">Email</p>
				<label className="switch">
					<input
					type="checkbox"
					onClick={this.handleSwitchChange}
					name="lessonAndFeedbackReminderEmail"
					defaultChecked={lessonAndFeedbackReminderEmail}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<hr className="hr"/>

				<h4 className="heading">Job opportunities</h4>
				<div className="Switch">
				<p className="label">Text messages</p>
				<label className="switch">
					<input
					type="checkbox"
					name="jobOpportunitiesText"
					onClick={this.handleSwitchChange}
					defaultChecked={jobOpportunitiesText}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<div className="Switch">
				<p className="label">Email</p>
				<label className="switch">
					<input
					type="checkbox"
					name="jobOpportunitiesEmail"
					onClick={this.handleSwitchChange}
					defaultChecked={jobOpportunitiesEmail}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<hr className="hr"/>

				<h4 className="heading">Updates and promotions</h4>
				<div className="Switch">
				<p className="label">Text messages</p>
				<label className="switch">
					<input
					type="checkbox"
					name="updatesAndPromoText"
					onClick={this.handleSwitchChange}
					defaultChecked={updatesAndPromoText}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<div className="Switch">
				<p className="label">Email</p>
				<label className="switch">
					<input
					type="checkbox"
					name="updatesAndPromoEmail"
					onClick={this.handleSwitchChange}
					defaultChecked={updatesAndPromoEmail}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<hr className="hr"/>

				<div className="Switch">
				<h4 className="heading">Unsubscribe from all marketing emails</h4>
				<label className="switch">
					<input
					type="checkbox"
					name="marketingEmails"
					checked={marketingEmails}
					onClick={this.handleSwitchChange}
					/>
					<span className="slider round"></span>
				</label>
				</div>
				<p className="label mb-3">
				This includes newsletters, learning inspirations, deals, blog articles, how 
				Askademia works, invites and referrals, surveys and research studies, tutoring tips and promotions.
				</p>
				<hr className="hr"/>

				<Button
				className="green-save-btn"
				style={{
					width: "104px",
					height: "56px",
					borderRadius: "5px",
					backgroundColor: "#2cb46d",
					fontSize: "16px",
					fontWeight: "600",
				}}
				onClick={this.UpdateNotification}
				>
				{loader ? <Spinner animation="border" /> : "Update"}
				</Button>
			</Col>
			</Row>
			<NotificationModal
			notificationModalOpen={notificationModalOpen}
			onclose={this.onClose1}
			unsubcribe={this.unsubcribe}
			/>
		</div>
		);
	}
}

export default TutorSettingNotification;
